import { render } from "./additional-field.vue?vue&type=template&id=3c255732"
import script from "./additional-field.vue?vue&type=script&lang=js"
export * from "./additional-field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__